export const config = {
    name: 'config',
    index: false,
    selection: true,
    height: 300,
    columns: [
        {
            label: '明细ID',
            prop: 'id',
            sort: true,
            amendState: true
        },
        {
            label: '客户商品编码',
            prop: 'customerItemCode',
            sort: true,
            width: 150
        },
        {
            label: '商品编码',
            prop: 'itemCode',
            sort: true,
            width: 100
        },
        {
            label: '商品名称',
            prop: 'itemName',
            sort: true,
            width: 150
        },
        {
            label: '包件数量',
            prop: 'pkgQty',
            sort: true
        },
        {
            label: '计划数量',
            sort: true,
            prop: 'planQty'
        },
        {
            label: '实装数量',
            sort: true,
            prop: 'actQty',
            width: 120,
            type: 'input',
            mustFill: true,
            verify: '^[0-9]+(\.[0-9]{1})?$'
        },
        {
            label: '实扫数量',
            prop: 'rfActLoadQty',
            sort: true,
            width: 100
        },
        {
            label: '生产批号',
            sort: true,
            prop: 'produceCode',
            width: 120
        },
        {
            label: '商品单价',
            sort: true,
            prop: 'price',
            width: 120
        }
    ],
    form: {
        loadDate: ''
    },
    rules: {
        loadDate: [{
            required: true,
            message: '请选择装车时间',
            trigger: 'blur'
        }]
    },
    action: [{
        type: 'text',
        label: '明细保存',
        size: 'mini',
        event: 'detailedSave',
        ifHas: '04040003'
    }],
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [
            10,
            20,
            30,
            50
        ]
    }
};
